/***
 * This module is used to keep track of data of static elements of the page, meaning elements that dont render but are saved in the page's content.
 * These elements can be edited immediately from the author
 * ***/

import Vue from "vue";
import { elementsListInfo } from "../../../../author/pagesbuilder/components/elements-list/ElementsListInfo.js";

export default {
    namespaced: true,
    state: {
        elementsData: {},
        elementsListInfo,
        elementsManagerInitFlag: false,
        elementStates: {},
        elementsManagerWrapper: null,
        registeredElements: [],
        elementTypesMapping: {
            button: "Button",
            buttonWrapper: "ButtonWrapper",
            column: "Column",
            columnWrapper: "ColumnWrapper",
            embed: "Embed",
            "context-wrapper": "ContextWrapper",
            "contact-form": "ContactForm",
            "contact-form-wrapper": "ContactFormWrapper",
            "contact-input": "ContactInput",
            framedImage: "FramedImage",
            "megamenu-wrapper": "MegamenuWrapper",
            hline: "HorizontalLine",
            hlineWrapper: "HorizontalLineWrapper",
            divider: "Divider",
            icon: "Icon",
            image: "Image",
            "media-gallery" : "MediaGallery",
            input: "Input",
            listItem: "ListItem",
            listWrapper: "ListWrapper",
            "lead-form": "LeadForm",
            "lead-form-wrapper": "LeadFormWrapper",
            screen: "Screen",
            "social-links-wrapper" : "SocialLinksWrapper",
            "social-share-button": "SocialShareButton",
            text: "Text",
            vdistance: "VerticalDistance",
            "affiliates-registration": "AffiliatesRegistration",
            "affiliates-button": "AffiliatesButton",
            "payment-manager" : "PaymentManager",
            "faq" : "Faq",
            "spacer": "Spacer",
            "lottie-animation": "LottieAnimation"
        }
    },
    actions: {
        addElementState({ commit }, payload) {
            commit("addElementState", payload);
        },
        editRegisteredElement({ commit }, payload) {
            commit("editRegisteredElement", payload);
        },
        registerElement({ commit }, payload) {
            commit("registerElement", payload);
        },
        unregisterElement({ commit }, payload) {
            commit("unregisterElement", payload);
        },
        setElementsData({ commit }, payload) {
            commit("setElementsData", payload);
        },
        setElementData({ commit, dispatch, state }, payload) {
            let elementState = state.elementStates[payload.elementId];

            if (elementState && elementState.hasContext("school-topbar")) {
                dispatch("topbar/setSchoolTopbarElementData",payload,{root:true});
            } else if (elementState && elementState.hasContext("page-topbar")) {
                dispatch("topbar/setPageTopbarElementData",payload,{root:true});
            } else if (elementState && elementState.hasContext("schoolFooter")) {
                dispatch("footer/setSchoolFooterElementData",payload,{root:true});
            } else if (elementState && elementState.hasContext("pageFooter")) {
                dispatch("footer/setPageFooterElementData", payload, {
                    root: true,
                });
            } else {
                commit("setElementData", payload);
            }
        },
        removeElementData({ commit, dispatch, state }, payload) {
            let elementState = state.elementStates[payload];

            if (elementState && elementState.hasContext("school-topbar")) {
                dispatch("topbar/removeSchoolTopbarElement",payload,{root:true});
            } else if (elementState && elementState.hasContext("page-topbar")) {
                dispatch("topbar/removePageTopbarElement",payload,{root:true});
            } else if (elementState && elementState.hasContext("schoolFooter")) {
                dispatch("footer/removeSchoolFooterElement",payload,{root:true});
            } else if (elementState && elementState.hasContext("pageFooter")) {
                dispatch("footer/removePageFooterElement", payload, {
                    root: true,
                });
            } else {
                commit("removeElementData", payload);
            }
        },
        setElementsManagerInitFlag({ commit }, payload) {
            commit("setElementsManagerInitFlag", payload);
        },
        setElementsManagerWrapper({ commit }, payload) {
            commit("setElementsManagerWrapper", payload);
        },
        removeElementState({ commit }, payload) {
            commit("removeElementState", payload);
        },
        initElementsManager({ commit }, payload) {
            commit("setElementsManagerWrapper", payload);
            commit("setElementsManagerInitFlag", true);
        },
    },
    mutations: {
        setElementData(state, data) {
            if (data) {
                if (typeof state.elementsData[data.elementId] === "undefined") {
                    Vue.set(state.elementsData, data.elementId, data);
                }

                for (let key in data) {
                    if (
                        !data.hasOwnProperty(key)
                        // || key === "elementId"
                    ) {
                        continue;
                    }

                    Vue.set(state.elementsData[data.elementId], key, data[key]);
                }
            }
        },
        removeElementState(state, elementId) {
            if (typeof state.elementStates[elementId] !== "undefined") {
                Vue.delete(state.elementStates, elementId);
            }
        },
        removeElementData(state, elementId) {
            if (typeof state.elementsData[elementId] !== "undefined") {
                Vue.delete(state.elementsData, elementId);
            }
        },
        setElementsData(state, elementsData) {
            state.elementsData =
                elementsData && !Array.isArray(elementsData)
                    ? elementsData
                    : {};
        },
        addElementState(state, elementState) {
            Vue.set(
                state.elementStates,
                elementState.elementId,
                elementState.state
            );
        },
        editRegisteredElement(state, data) {
          if (data.action === "replaceTempId") {
              //FIXME: Why Array.map??  use find or findIndex instead
                state.registeredElements.map(
                    (elementRegistrationData, index) => {
                        if (
                            data.tempId &&
                            elementRegistrationData.tempId === data.tempId
                        ) {
                            elementRegistrationData.elementId = data.elementId;
                            Vue.delete(data, "tempId");
                        }
                    }
                );
            }
        },
        registerElement ( state , registrationData) {
            state.registeredElements.push(registrationData);
        },
        unregisterElement(state, elementId) {
            //FIXME: Why Array.map??  use find or findIndex instead
            state.registeredElements.map((elementRegistrationData, index) => {
                if (elementRegistrationData.elementId === elementId) {
                    Vue.delete(state.registeredElements, index);
                }
            });
        },
        setElementsManagerInitFlag(state, flag) {
            state.elementsManagerInitFlag = flag;
        },
        setElementsManagerWrapper(state, wrapper) {
            state.elementsManagerWrapper = wrapper;
        },
    },
};
